import React from "react";
import "../assets/css/noPage.css";

const NoPage = () => {
  return (
    <div className="no-page-container">
      <h1>404 PAGE NOT FOUND</h1>
    </div>
  );
};

export default NoPage;
